import { createSelector } from '@reduxjs/toolkit';

import { ExternalInvitation } from '@/domain/external-invitation/entities/external-invitation.entity';
import { RootState } from '@/domain/store';

export const selectExternalInvitationSurveys = (state: RootState) =>
  state.externalInvitationSurvey.items
    .filter((invitation) => invitation.status !== 'ARCHIVED')
    .sort(sortByCreatedAtAsc);

export const selectExternalInvitationSurveyIsFetching = (state: RootState) =>
  state.externalInvitationSurvey.isFetching;

export const selectSurveyResultByInvitationId =
  (id: number) => (state: RootState) =>
    state.externalInvitationSurvey.resultsByInvitationId[id];

export const checkUserCanCreateSurvey = createSelector(
  [selectExternalInvitationSurveys],
  (surveys) => {
    const MAX_SURVEYS = 10;
    const canCreateSurvey = surveys.length < MAX_SURVEYS;
    return canCreateSurvey;
  },
);

const sortByCreatedAtAsc = (a: ExternalInvitation, b: ExternalInvitation) =>
  new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
